import React from "react";
import { useStyles } from "./style";

interface InfoCardProps {
  label: string;
  value: string;
}

export const InfoCard: React.FC<InfoCardProps> = ({ label, value }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        <div className={classes.title}>{label}</div>
        <div className={classes.value}>{value}</div>
      </div>
    </div>
  );
};
